import { action, makeObservable, observable } from 'mobx';

import { Model } from './Model';

export interface ISocialNetworkModel {
    id?: number;
    sort?: number;
    name?: string;
    image?: string;
    link?: string;
}

export class SocialNetworkModel extends Model implements ISocialNetworkModel {
    id = 0;
    sort = 0;
    name = '';
    image = '';
    link = '';

    constructor(payload: ISocialNetworkModel = {}) {
        super();

        makeObservable(this, {
            id: observable,
            sort: observable,
            name: observable,
            image: observable,
            link: observable,
            update: action,
        });

        this.update(payload);
    }
}
